export default class columnasService{
	constructor(){
		this.columnas = {
            inventario: {
                ACSA: ['numeroDeSerie', 'nombre', 'numeroDeEquipo', 'tipoDeOperacion', 'subparte', 'respuesto',
                        'revision', 'tipoDeCategoria', 'estadoDeEquipo', 'proyecto', 'ubicacion'],
                SCADA: ['numeroDeSerie', 'nombre', 'revision', 'tipoDeCategoria', 'estadoDeEquipo', 'proyecto', 'ubicacion', 'tipoDeEquipo'],
                default: ['numeroDeSerie', 'nombre', 'revision', 'tipoDeCategoria', 'estadoDeEquipo', 'proyecto', 'ubicacion', 'tipoDeEquipo']
            },
            ott: {
                ACSA: ['numero', 'numeroDeEquipo', 'avance', 'glpi', 'fechaAgendada', 'fechaInicio', 'equipoLugar',
                     'tipoDeOtt', 'tipoDeObra', 'estado'],
                SCADA: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero'],
                SC: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero'],
                AVO: ['tipoDeOtt', 'numero_ticket','fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar','ubicacion', 'numero'],
                VN: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero'],
                INTERVIAL: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero'],
                CN: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero'],
                default: ['tipoDeOtt', 'fechaAgendada', 'fechaInicio', 'estado', 'equipoLugar', 'numero']
            }
        }
	}

    getColumnasInventario(cliente){
        if (this.columnas.inventario.hasOwnProperty(cliente)) {
            return this.columnas.inventario[cliente]
        } else {
            return this.columnas.inventario.default
        }        
    }

    getColumnasOtt(cliente){
        if (this.columnas.ott.hasOwnProperty(cliente)) {
            return this.columnas.ott[cliente]
        } else {
            return this.columnas.ott.default
        }        
    }
}



// WEBPACK FOOTER //
// ./app/js/services/columnasService.js